import { CCard, CNav, CNavItem, CNavLink } from "@coreui/react"
import {Button,  Dropdown, Input, Space, Card } from "antd"
import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import AntdTable from "src/components/AntdTable/Table"
import { DownOutlined, SearchOutlined } from "@ant-design/icons"
import {
    cancelMailingActions,
  getMailingTypes,
  mailingsContentListAction,
  mailingsInfoListAction,
} from "src/store/Slices/MailingsSlice"

//import { Button } from "@mui/material"

const MailingsContent = ({
  mailingsContent,
  setMailingsContent,
  mnemo,
  columns,
  data,
}) => {
  const dispatch = useDispatch()
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(5)
  const [selectedKeys, setSelectedKyes] = useState("")
  const [dataIndex, setDataIndex] = useState("")
  const [sortByIdFrom, setSortByIdFrom] = useState()
  const [sortByIdTo, setSortByIdTo] = useState()
  const [selectedMailing, setSelectedMailing] = useState()
  const cancelLoading = useSelector((state) => state.MailingsSlice.cancelLoading)
  //STORE
  const mailingsContentList = useSelector(
    (state) => state.MailingsSlice.mailingsContentList
  )
  const mailingsContentListLoading = useSelector(
    (state) => state.MailingsSlice.mailingsContentListLoading
  )

  const handleReset = (clearFilters) => {
    setPage(1)
    setPageSize(20)
    dispatch(getAbonementsList())
    clearFilters()
    setSortByIdFrom()
    setSortByIdTo()
  }

  const onClickSearchItem = (selectedKeys, dataIndex) => {
    setPage(1)
    setPageSize(20)
    dispatch(
      mailingsContentListAction({
        from: sortByIdFrom,
        to: sortByIdTo,
        // orderBy: ,
        // isDesc:,
        // typeId: 3,
        offset: pageSize * (page - 1),
        count: pageSize,
        // order:
        // desc:
        // typeId:
      })
    )
  }
  const searchInput = useRef(null)
  // const getColumnSearchProps = (dataIndex, title) => ({
  //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
  //         <div
  //             style={{
  //                 padding: 8,
  //             }}
  //             onKeyDown={(e) => e.stopPropagation()}
  //         >
  //             {/* <div>
  //                 {title !== '№' && <Input
  //                     ref={searchInput}
  //                     placeholder={`Искать ${title}`}
  //                     value={selectedKeys[0]}
  //                     onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
  //                     onPressEnter={() => onClickSearchItem(selectedKeys, dataIndex)}
  //                     style={{
  //                         marginBottom: 8,
  //                         display: 'block',
  //                     }}
  //                 />}
  //                 {(title === '№') &&
  //                     <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
  //                         <Input
  //                             placeholder='От'
  //                             type='number'
  //                             value={sortByIdFrom}
  //                             onChange={e => setSortByIdFrom(e.currentTarget.value)}
  //                         />
  //                         <Input
  //                             placeholder='До'
  //                             type='number'
  //                             value={sortByIdTo}
  //                             onChange={e => setSortByIdTo(e.currentTarget.value)}
  //                         />
  //                     </div>
  //                 }
  //             </div> */}
  //             <Space>
  //                 <Card
  //                     type="primary"
  //                     onClick={() => onClickSearchItem(selectedKeys, dataIndex)}
  //                     icon={<SearchOutlined />}
  //                     size="small"
  //                     style={{
  //                         width: 90,
  //                     }}
  //                 >
  //                     Искать
  //                 </Card>
  //                 <Card
  //                     onClick={() => {
  //                         if (clearFilters) {
  //                             handleReset(clearFilters)
  //                         }
  //                     }}
  //                     size="small"
  //                     style={{
  //                         width: 90,
  //                     }}
  //                 >
  //                     Сбросить
  //                 </Card>
  //                 <Card
  //                     type="link"
  //                     size="small"
  //                     onClick={() => {
  //                         close();
  //                     }}
  //                 >
  //                     Закрыть
  //                 </Card>
  //             </Space>
  //         </div>
  //     ),
  //     filterIcon: (filtered) => (
  //         <SearchOutlined
  //             style={{
  //                 color: filtered ? '#1677ff' : undefined,
  //             }}
  //         />
  //     ),
  //     onFilter: (value, record) =>
  //         record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
  //     onFilterDropdownOpenChange: (visible) => {
  //         if (visible) {
  //             setTimeout(() => searchInput.current?.select(), 100);
  //         }
  //     },
  //     render: (text) =>
  //         text
  // });

  const onClickRowOne = (record) => {
    setMailingsContent(record)
    dispatch(mailingsInfoListAction({ mailingId: record.id }))
    //debugger
  }
  const rowClassName = (record) => {
    return record?.key === mailingsContent?.key ? "" : "selected-row"
  }

  const handleTableChange = (pagination, filters, sorter) => {
    dispatch(
      mailingsContentListAction({
        count: pagination.pageSize,
        offset: pagination.pageSize * (pagination.current - 1),
        from: sortByIdFrom,
        to: sortByIdTo,
        orderBy: sorter?.column?.dataIndex,
        isDesc: sorter.order
          ? sorter.order === "ascend"
            ? true
            : false
          : undefined,
        typeId: 3,
      })
    )
    debugger
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
  }
  // useEffect(() => {
  //     dispatch(getMailingTypes())
  // },[])
  const addZeroHandler = (_time) => {
    const time = _time.toString()
    if (time.length === 1) {
      return `0${time}`
    }
    return time
  }
  const formatIsoToDate = (_date) => {
    return (
      _date.slice(8, 10) + "." + _date.slice(5, 7) + "." + _date.slice(0, 4)
    )
  }

  const formatIsoToTime = (_date) => {
    const hours = _date.slice(11, 13)
    const minutes = _date.slice(14, 16)
    const seconds = _date.slice(17, 19)
    return (
      addZeroHandler(+hours) +
      ":" +
      addZeroHandler(+minutes) +
      ":" +
      addZeroHandler(+seconds)
    )
  }
  const dataSource = mailingsContentList?.data?.value?.rows.map((element) => {
    return {
      id: element.id,
      header: element.header,
      body: element.body,
      usersAmount: element?.usersAmount,
      supposedSendDate:
        element?.supposedSendDate &&
        formatIsoToDate(element?.supposedSendDate) +
          ` ` +
          formatIsoToTime(element?.supposedSendDate),
      sendDate:
        element?.sendDate &&
        formatIsoToDate(element?.sendDate) +
          ` ` +
          formatIsoToTime(element?.sendDate),
      typeName: element?.typeName,
      // usersAmount: element?.usersAmount && formatIsoToDate(element?.timeCall) + ` ` + formatIsoToTime(element?.timeCall),
    }
  })
  const title = () => {
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <CNav variant='tabs'>
          <CNavItem>
            <CNavLink style={{ cursor: "pointer" }} active={true}>
              Справочник рассылок
            </CNavLink>
          </CNavItem>
        </CNav>
      </div>
    )
  }

  const items = [
    {
      key: "1",
      label: "Отменить рассылку",
      onClick: () => {
        if(selectedMailing){
          handleCancelMailing(selectedMailing)
        }
      },
      //disabled: selectedMailing?.sendDate || !mnemo?.children?.find((el) => el.mnemo === "update-btn")
     
    }
  ] 

  const handleClick = async(record) => {
    console.log("Рассылка отменена")
    try{
        await dispatch(cancelMailingActions(record.id)).unwrap();
        dispatch(mailingsContentListAction({
            count: pageSize,
            offset: pageSize * (page - 1),
            typeId: 3,
        }))

        if (mailingsContent?.id === record.id) {
          setMailingsContent(null);
        }
    }catch(error){
        console.log("Ошибка при отмене рассылки", error)
    }
  }

  return (
    <div>
      <AntdTable
        pageSize={pageSize}
        setPageSize={setPageSize}
        page={page}
        setPage={setPage}
        loading={mailingsContentListLoading}
        columns={
          mailingsContentList && [
            ...mailingsContentList?.data?.value?.columns.map((element) => {
              return {
                ...element,
                ellipsis: true,
                // ...getColumnSearchProps(element.dataIndex, element.title),
              }
            }),
            {
                title: 'Действия',
                key: 'actions',
                width: 120,
                //fixed: 'right',
                render: (_, record) => (
                    <Button
                        
                        // style={{
                        //   color: '#1890ff',
                        //   borderColor: '#1890ff',
                          
                        // }}
                       type='primary'
                        
                        loading={cancelLoading}
                        onClick={(e) => {
                          e.stopPropagation()
                          handleClick(record)}
                        }
                        //disabled={record.sendDate}
                    >
                        Отменить
                        {/* {record.sendDate ? 'Отправить' : 'Отменить'} */}
                    </Button>
                )
            }
          ]
        }
        rows={dataSource}
        scroll={{ x: 0, y: 300 }}
        title={title}
        onClickRowOne={onClickRowOne}
        onChange={handleTableChange}
        total={mailingsContentList?.data?.value?.totalCount}
        rowClassName={rowClassName}
      />
    </div>
  )
}

export default MailingsContent
